import React, { PureComponent } from "react";

class Person extends PureComponent {
  render() {
    return (
      <div className="box">
        <div className="row">
          <div className="col-3">
            <a href={this.props.link} target="_blank" rel="noopener noreferrer" className="link">
              <img src={"images/" + this.props.image} className="rounded-circle img-fluid" alt={this.props.name} />
            </a>
          </div>
          <div className="col-9 align-self-center">
            <h5>{this.props.name}</h5>
            <h6>{this.props.title}</h6>
            {
              this.props.title2 ? <h6>{this.props.title2}</h6> : null
            }
          </div>
        </div>
        <p>{this.props.desc}</p>
      </div>
    )
  }
}

class Judges extends PureComponent {
  render() {
    return (
      <section id="judges">
        <div className="container">
          <div className="title-block">
            <h2>Judges</h2>
            <p>Our panel of prestigious judges will be selecting teams from each category with the most unique and creative solutions.</p>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Person
                name="Professor Bo An"
                image="judge-prof-bo-an.jpg"
                link="http://www.ntu.edu.sg/home/boan/"
                title="Associate Professor, School of Computer Science and Engineering, NTU"
                desc="Professor Bo An is an Associate Professor at  Nanyang Technological University, Singapore whose research interests include artificial intelligence, multiagent systems, game theory, and optimization. He is recipient of numerous awards including INFORMS Daniel H. Wagner Prize for Excellence in Operations Research Practice, winner of 2017 Microsoft Collaborative AI Challenge, and 2018 IEEE Intelligent Systems' AI's 10 to Watch."
              />
            </div>
            <div className="col-md-6">
              <Person
                name="Professor Dai Bing Tian"
                image="judge-prof-dai-bing-tian.jpg"
                link="https://www.smu.edu.sg/faculty/profile/146776/DAI-Bing-Tian"
                title="Assistant Professor of Information Systems"
                title2="Director, MITB (Artificial Intelligence) Programme, SMU"
                desc="Dr. Dai Bing Tian is an Assistant Professor at the School of Information Systems, Singapore Management University. His main research interests are data mining and machine learning, and he teaches master-level machine learning courses and algorithm design courses. He is also the director for the Master of IT in Business (Artificial Intelligence) programme."
              />
            </div>
            <div className="col-md-6">
              <Person
                name="Professor Ng See Kiong"
                image="judge-prof-ng-see-kiong.jpg"
                link="https://www.comp.nus.edu.sg/cs/bio/ngsk/"
                title="Director, Translational Research (Data Science)"
                title2="Professor(Practice), Computer Science, NUS"
                desc="Professor Ng See Kiong is a Professor of Practice at the National University of Singapore, and Director, Translational Research for the university's Institute of Data Science.  As an early practitioner of data mining and machine learning with diverse and cross-disciplinary research interests, his research mission is to develop artificial intelligence techniques to obtain better insights and understanding of the world through computation of data."
              />
            </div>
            <div className="col-md-6">
              <Person
                name="Dr. Pan Yaozhang"
                image="judge-pan-yaozhang.jpg"
                link="https://www.linkedin.com/in/yaozhang-pan-75b10333/?originalSubdomain=sg"
                title="Head of Data Science, Shopee"
                desc="Dr. Pan Yaozhang is the Head of Data Science at Shopee, having built the data science team from scratch. She is committed to introducing the most advanced technologies of machine learning and artificial intelligence into industrial and commercial applications. Before Shopee, she worked for Grab, Greenwave Systems, and was a research scientist at the Institute for Infocomm Research, A*STAR."
              />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Judges;